export enum LiveEndpointKeys {
  getLive = 'getLive'
}
